import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

type AppState = {
    marketCode: string;
    languageCode: string;
    deviceType: string;
    tipsType: string;
    isInitialized: boolean;
    initialGuideItemType: string | null | undefined;
};

const getInitialState = (): AppState => {
    return {
        marketCode: '',
        languageCode: '',
        deviceType: '',
        tipsType: '',
        isInitialized: false,
        initialGuideItemType: undefined,
    };
};

export const slice = createSlice({
    name: 'app',
    initialState: getInitialState(),
    reducers: {
        setMarketCode: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                marketCode: action.payload,
            };
        },
        setLanguageCode: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                languageCode: action.payload,
            };
        },
        setDeviceType: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                deviceType: action.payload,
            };
        },
        setTipsType: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                tipsType: action.payload,
            };
        },
        setInitialized: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isInitialized: action.payload,
            };
        },
        setInitialGuideItemType: (state, action: PayloadAction<string | undefined>) => {
            return {
                ...state,
                initialGuideItemType: action.payload,
            };
        },
    },
});

export const {setMarketCode, setLanguageCode, setDeviceType, setTipsType, setInitialized, setInitialGuideItemType} =
    slice.actions;
export default slice.reducer;
